export default __webpack_public_path__ + "static/media/Pravakar Mishra.042f7888.jpeg";